<div class="row justify-content-center position-relative col-12" style="margin-top: 15vh;">
  <div style="margin-left: 10%; margin-right: 5%;">
    <div style="z-index: 100;background-color: white;" class="row mt-2 mr-0 d-flex">
      <h1 class="font-weight-bold text-uppercase ml-3">Compare</h1>
      <div class="filter-icon ml-auto">
        <button class="btn btn-filter text-white mr-2 trigger-collapse-btn" title="Filter" (click)="showFilter = !showFilter">
          <i class='fas fa-filter'></i></button>
      </div>
    </div>
    <div>
      <div *ngIf="showFilter">
        <form class="row" [formGroup]="form" (submit)="submitSearch()">
          <div class="col-12">
            <h5 class="title">Load types</h5>
            <label class="radio-inline" *ngFor="let loadTestTypes of loadTestTypes">
              <input type="radio" name="loadTestType" value="{{ loadTestTypes }}" formControlName="loadTestType" (change)="resetApiType()" />
              {{ loadTestTypes }}
            </label>
            <hr />
          </div>
          <div class="col-3 mb-2">
            <ng-select class="custom-style" [clearable]="false" id="my-project" formControlName="projectIds" placeholder="Select Project(s)" [items]="userProjects" (change)="getProjectRelatedData()" bindLabel="name" bindValue="id">
              <ng-template ng-option-tmp let-item="item">
                <div title="{{ item.name }}" class="text-truncate">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-3 mb-2">
            <ng-select class="custom-style" [clearable]="false" formControlName="testCaseId" placeholder="Select testcase" [items]="testCasesList" bindLabel="name" bindValue="id" (change)="submitSearch()"></ng-select>
          </div>
          <div class="col-3 mb-2">
            <ng-select class="custom-style" [multiple]="true" id="project-user" formControlName="userIds" placeholder="Select Users(s)" bindLabel="displayName" bindValue="id" [items]="projectUsers"></ng-select>
          </div>
          <div class="col-3 mb-2">
            <ng-select class="custom-style" formControlName="executionStatus" [items]="executionStatuses" placeholder="Select Status"></ng-select>
          </div>
          <div class="col-3">
            <ng-select class="custom-style" [clearable]="false" formControlName="location" placeholder="Location" [items]="locations"></ng-select>
          </div>
          <div class="col-3">
            <input class="form-control form-control-sm" type="text" placeholder="Start Date" name="dt" formControlName="startDate" (click)="dt.toggle()" ngbDatepicker #dt="ngbDatepicker" placement="bottom" (dateSelect)="setEndDate($event)" [maxDate]="startdate" autocomplete="off" />
          </div>
          <div class="col-3">
            <input class="form-control form-control-sm" type="text" placeholder="End Date" name="dt1" formControlName="endDate" (click)="dt1.toggle()" ngbDatepicker #dt1="ngbDatepicker" placement="bottom" (dateSelect)="setDate($event)" [minDate]="enddate" [maxDate]="startdate" autocomplete="off" />
          </div>

          <div class="col text-right">
            <button type="submit" class="btn relay-btn primary" [disabled]="!projectIdsValue || !testCaseIdValue">Search</button>
            <a style="display: block;color:white;" class="mt-2 clickable" (click)="clearFilter()">
              <small><i>Clear filter</i></small>
            </a>
          </div>
        </form>
      </div>

    </div>
    <table class="table list-table-design">
      <thead class="TableHead">
        <tr class="list-table-row">
          <th width="5%"></th>
          <th class="text-left" width="20%">Testname</th>
          <th width="5%">Type</th>
          <th class="text-center" width="10%">Location</th>
          <th class="text-center" width="10%">Users</th>
          <th class="text-center" width="30%">Schedule Date & Time</th>
          <th width="5%">Status</th>
          <th width="10%" *ngIf="userData?.perfLabAdmin">Created By</th>
          <th width="5%"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!queueData">
          <td colspan="8">Please select project and testcase</td>
        </tr>
        <tr *ngIf="queueData && collectionSize === 0">
          <td colspan="10" class="text-center">
            <img height="100px" src="/assets/images/icons/empty_message.png" alt="/assets/images/icons/empty_message.png">
            <p style="color: gray;" class="ml-3 mt-1"><b>No Data Found</b></p>
          </td>
        </tr>
        <tr *ngFor="let queueData of queueData?.performanceRequests" class="clickable">
          <td>
            <input type="checkbox" [(ngModel)]="queueData.selected" />
          </td>
          <td>
            <a target="_blank" [routerLink]="['/testcase', queueData.testCase.id]"> <i class="fas fa-link" ngbTooltip="Go to Testcase"></i></a>
            <a ngbTooltip="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}" class="text-truncate" [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'" title="{{ queueData.testCase.name }}" style="padding-left: 0.2em">{{ queueData.testCase?.name }}</a>
          </td>
          <td class="text-center">{{ queueData.testCase?.loadTestType }}</td>
          <td class="text-center">
            <a ngbTooltip="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}" [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'">{{
                  queueData.location ? queueData.location : "NA" }}</a>
          </td>
          <td class="text-center">
            <a ngbTooltip="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}" [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'">{{
                  queueData.noOfUsers > 9 ? queueData.noOfUsers : "0" + queueData.noOfUsers }}</a>
          </td>
          <td class="text-center" title="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}">
            <a [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'">
              {{ queueData.startTime | date:'dd-MM-yy, hh:mm:ss A' }} to
              {{ queueData.endTime | date:'dd-MM-yy, hh:mm:ss A' }}
            </a>
          </td>
          <td class="text-center">
            <div class="status-badge status-{{ queueData.status.toLowerCase() }}" [title]="queueData.status">
              <i class="fas" [ngClass]="{
                    'fa-check-circle': queueData.status === 'PASSED',
                    'fa-times-circle': queueData.status === 'FAILED',
                    'fa-sync-alt fa-spin': queueData.status === 'IN_PROGRESS',
                    'fa-clock': queueData.status === 'SCHEDULED',
                    'fa-hand-paper': queueData.status === 'ABORTED',
                    'fa-hourglass-half': queueData.status === 'PENDING'
                  }"></i>
              <!-- {{ queueData.status }} -->
            </div>
          </td>
          <td class="text-center template-word-wrap" *ngIf="userData.perfLabAdmin" title="{{ queueData.createdBy?.displayName }}">
            <span style="font-size: 11px">{{ queueData.createdBy ? queueData.createdBy.userName : "" }}</span>
          </td>
          <td class="text-right">
            <button class="btn btn-sm btn-icon" title="Re-run" [routerLink]="['/performance/loadTesting/rerun/', queueData.id]">
              <i class="fas fa-redo"></i>
            </button>
          </td>
        </tr>
        <div *ngIf="queueData?.performanceRequests?.length === 0 && collectionSize && collectionSize !== 0">
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
        </div>
      </tbody>
    </table>
    <div class="row my-4 pb-5" *ngIf="queueData?.performanceRequests?.length > 0">
      <div class="col font-weight-bold">Total Results : {{ collectionSize || 0 }}</div>
      <div class="col-1" *ngIf="queueData?.performanceRequests">
        <select class="" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
          <option>15</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
      <div class="col-md-auto" *ngIf="queueData?.performanceRequests?.length && queueData?.performanceRequests?.length">
        <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [(page)]="page" [boundaryLinks]="true" [rotate]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
<section appStickyNav scrollTopVal="100" class="controls-fixed" *ngIf="queueData?.performanceRequests?.length > 0">
  <div class="row relay-margin-top-10">
    <div class="d-flex m-auto" *ngIf="queueData">
      <button class="btn relay-btn primary" (click)="goToCompareResult()"
        [disabled]="disableCompare() < 2">COMPARE</button>
    </div>
  </div>
</section>
